/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React,{useState,useEffect} from "react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
} from "reactstrap";
import firebase from '../config/firebase'
function Tables() {

  return (
    <>
      <div className="content">
      <table class="table table-hover">
  <thead>
    <tr>
      <th scope="col">#</th>
      <th scope="col">Name</th>
      <th scope="col">Billing Address</th>
      <th scope="col">Transation ID</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <th scope="row">1</th>
      <td>Awais</td>
      <td>tariq street, mohalla pir, bahar shah,skp</td>
      <td>D763893834</td>
    </tr>
    <tr>
      <th scope="row">2</th>
      <td>Awais</td>
      <td>tariq street, mohalla pir, bahar shah,skp</td>
      <td>D763893834</td>
    </tr>
    <tr>
      <th scope="row">3</th>
      <td>Awais</td>
      <td>tariq street, mohalla pir, bahar shah,skp</td>
      <td>D763893834</td>
    </tr>
    <tr>
      <th scope="row">4</th>
      <td>Awais</td>
      <td>tariq street, mohalla pir, bahar shah,skp</td>
      <td>D763893834</td>
    </tr>
      </tbody>
</table>
      </div>
    </>
  );
}

export default Tables;
